// Interface representing a loaded ML model from the backend
export interface LoadedMlModel {
    modelId: string;
    name: string;
    revision: string;
    service: string;
    hostingType: string;
    gpu: string;
    gpuMemory: string;
    lastActivity: string | null;
}

// Enum representing the target ML model service for unloading
// Must match backend TargetMlModelServiceEnum values
export enum TargetMlModelService {
    SmartTags = 'SmartTags',
    TextProcessing = 'TextProcessing'
}
